import React, { useState, useEffect } from 'react';

const NonMedicalDeviceType = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.EUProductUDI.IntendedPurposeOtherThanMedicalAnnexXVI",
    fieldTitle = "Intended Purpose Other than Medical (Annex XVI)",
    forceIsEditing = null
}) => {
    // Option mapping from your Dictionary
    const purposeOptions = [
        { key: "BRAIN_ELECTROSTIMULATION", value: "Brain Electrostimulation" },
        { key: "CONTACT_LENSES", value: "Contact Lenses" },
        { key: "EMR", value: "EMR" },
        { key: "EQUIPMENT_FOR_ADIPOSE_TISSUE", value: "EQUIPMENT FOR ADIPOSE TISSUE" },
        { key: "FILLING_BY_INJECTION", value: "FILLING BY INJECTION" },
        { key: "PRODUCT_IN_BODY", value: "PRODUCT IN BODY" },
    ];

    // Parse initial data
    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        } catch {
            return [];
        }
    });

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);

    // Local state for the dropdown selection
    const [selectedValue, setSelectedValue] = useState(purposeOptions[0].key);

    const handleAdd = () => {
        const selectedOption = purposeOptions.find(opt => opt.key === selectedValue);

        const newItem = {
            IntendedPurpose: selectedOption.key,
            IntendedPurposeText: selectedOption.value
        };

        const updatedItems = [...items, newItem];

        // 1. Update local UI state
        setItems(updatedItems);

        // 2. Update Global
        setUDI(prevItem => ({
            ...prevItem,
            IntendedPurposeOtherThanMedicalAnnexXVI: updatedItems
        }));
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);

        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            IntendedPurposeOtherThanMedicalAnnexXVI: updatedItems
        }));
    };



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);



    // --- Render Mode: Edit ---
    return (


        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?


                            <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Intended Purpose</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.IntendedPurposeText}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="udiRemoveButton"
                                                        onClick={() => handleRemove(index)}
                                                    >
                                                        <i className="fas fa-times-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div style={{ marginTop: '15px' }}>
                                    Intended Purpose:
                                    <br />
                                    <select
                                        value={selectedValue}
                                        onChange={(e) => setSelectedValue(e.target.value)}
                                        style={{ width: '90%' }}
                                    >
                                        {purposeOptions.map((opt) => (
                                            <option key={opt.key} value={opt.key}>
                                                {opt.value}
                                            </option>
                                        ))}
                                    </select>
                                    <br /><br />

                                    <input
                                        type="button"
                                        className="udiActionButton"
                                        value="Add Intended Purpose"
                                        onClick={handleAdd}
                                    />
                                </div>

                                {/* Hidden field for legacy form submission compatibility */}
                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(items)} />
                            </div>

                            :


                            <>

                                <table className="dataTable" style={{ borderWidth: '1px', width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Intended Purpose</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.IntendedPurposeText}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/*
						        <input
							        type="button"
							        className="udiActionButton"
							        value="Edit"
							        onClick={() => changeIsEditingField(true)}
						        />
                                */}


                            </>

                        }

                    </div>

                </div>
            </div>
        </div>


    );
};

export default NonMedicalDeviceType;